import { useFormContext } from "react-hook-form";
import { InputProps } from "./types";

export const HiddenInput = (props: InputProps) => {
    const {
        name,
        fieldOptions = {},
        ...rest
    } = props;

    const { register } = useFormContext();

    return (
        <input
            id={name}
            type="hidden"
            {...register(name, fieldOptions)}
            {...rest} />
    );
}

export default HiddenInput;